import { createActionTypeModel } from "../../../../store/global/action-model";

export const ARTISTS = createActionTypeModel('ARTISTS')

export const SELECTED_ARTIST = createActionTypeModel('SELECTED_ARTIST');

export const SET_ARTIST_DETAILS = 'SET_ARTIST_DETAILS';



// SELECTED_ARTIST_DATA Action Types

export const GET_SELECTED_ARTIST_DATA = 'GET_SELECTED_ARTIST_DATA';
export const FETCH_SELECTED_ARTIST_DATA = 'FETCH_SELECTED_ARTIST_DATA';
export const SET_SELECTED_ARTIST_DATA = 'SET_SELECTED_ARTIST_DATA';
export const INSERT_SELECTED_ARTIST_DATA = 'INSERT_SELECTED_ARTIST_DATA';
export const UPDATE_SELECTED_ARTIST_DATA = 'UPDATE_SELECTED_ARTIST_DATA';
export const DELETE_SELECTED_ARTIST_DATA = 'DELETE_SELECTED_ARTIST_DATA';


export const RELATED_CONTACTS = createActionTypeModel('RELATED_CONTACTS');
export const ARTIST_FILES = createActionTypeModel('ARTIST_FILES');
export const ARTIST_RELATED_INFO = createActionTypeModel('ARTIST_RELATED_INFO');
export const ARTIST_RELATED_USER = createActionTypeModel('ARTIST_RELATED_USER');
export const ARTIST_RELATED_COUNTRIES = createActionTypeModel('ARTIST_RELATED_COUNTRIES');

export const UPLOAD_ARTIST_CUSTOM_DATA = 'UPLOAD_ARTIST_CUSTOM_DATA';
export const ADD_ARTIST_CUSTOM_DATA = 'ADD_ARTIST_CUSTOM_DATA';
export const SET_ARTIST_CUSTOM_DATA = 'SET_ARTIST_CUSTOM_DATA';


export const FILTER_ARTIST_BOOKING_LIST = 'FILTER_ARTIST_BOOKING_LIST';
export const NEXT_ARTIST_BOOKINGS = 'NEXT_ARTIST_BOOKINGS';
export const ADD_TRACK = 'ADD_TRACK';
export const DELETE_TRACK = 'DELETE_TRACK';


export const SEARCH_ARTIST = 'SEARCH_ARTIST';
export const FILTER_ARTIST_BY_USER = 'FILTER_ARTIST_BY_USER';
export const CREATE_ARTIST = 'CREATE_ARTIST';
export const DELETE_ARTIST = 'DELETE_ARTIST';



export const ArtistExternalLinks = createActionTypeModel('ArtistExternalLinks');

export const ArtistDetails = createActionTypeModel('ArtistDetails');
export const ArtistDetailMap = createActionTypeModel('ArtistDetailMap');